export const stringToDuskAttribute = (value) => value?.toLowerCase()
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll(' ', '-') || '';
